export class Catalog {

	constructor() {
		this.form = $('.catalog-all__filters input')
		// this.url = window.location.href
		// this.http = this.url.substring(0, this.url.indexOf('://') + '://'.length)
		// this.url = this.url.substring(this.url.indexOf(this.http) + this.http.length)
		// this.server = this.url.substring(0, this.url.indexOf('/') + '/'.length)
		// this.url = this.url.substring(this.url.indexOf(this.server) + this.server.length)
		// let params = ''
		// if (this.url.indexOf('?') > -1) {
		// 	params = this.url.substring(this.url.indexOf('?') + 1)
		// 	if(params[params.length-1] == '&') params = params.substring(0, params.length - 1)
		// 	this.url = this.url.substring(0, this.url.indexOf('?'))
		// 	if(params)
		// 		this.unserialize(params)
		// }
		// else {
		// 	this.setСlassId()
		// }
		// if(params)
		// 	this.getData(params)
	}

	unserialize(url) {
		// let params = this.to_object(url)
		// let inputs = Object.values(this.form[0])
		// let count = 0
		// for(let i = 0; i < inputs.length; i++) {
		// 	if(inputs[i].nodeName == 'INPUT') {
		// 		if(inputs[i].type == 'search') {
		// 			if(this.in_array(inputs[i].name, Object.keys(params))) {
		// 				inputs[i].setAttribute('value', params[inputs[i].name])
		// 			}
		// 		}
		// 		if(inputs[i].type == 'checkbox') {
		// 			let type = inputs[i].id.substring(0, inputs[i].id.indexOf('_'))
		// 			if(inputs[i].checked) {
		// 				count++
		// 			}
		// 		}
		// 	}
		// }
		// let full = Object.values(this.to_object(url)).filter(n => n)
		// if(count == 0 || full == 0 || (count == 1 && full.length == 1 && full[0] == this.getCookie('class_id'))) {
		// 	window.location.href = this.http + this.server + this.url
		// }
	}

	loadItems(input)
	{
		let req = this.form.serialize()
		if(req[req.length-1] == '&') req = req.substring(0, req.length - 1)
		if(input && input.id && input.nodeName && input.nodeName == 'INPUT' && input.type == 'checkbox') {
			if(input.checked)
				input.removeAttribute('checked')
			else
				input.setAttribute('checked','')
			
			let popur_input = $('.popup.popup-colors').find('#' + input.id)[0] ? $('.popup.popup-colors').find('#' + input.id)[0] : false
			if(popur_input) {
				if(popur_input.checked)
					popur_input.removeAttribute('checked')
				else
					popur_input.setAttribute('checked','')
			}
		}
		this.getData(req)
	}

	changePage(p)
	{
		window.scrollTo(0,0)
		primerka.set_cookie('catalog_step',p)
		$('.catalog-filters input[type=hidden][name=p]').val(p);
		this.loadItems($('.catalog-filters'));
	}

	toggleFav(itemId, parent)
	{
		var el = $(parent)

		if (el.hasClass("active")) var action = "del"
		else var action = "add"

		$.ajax({
			url: "/ajax.php?mid=12",
			type: "POST",
			data: {
				action: action,
				item_id: itemId,
			},
			dataType: "json",
			success: function(res) {
				if (res["success"]) {
					if (res["added"]) {
						el.addClass("active")
					} else {
						el.removeClass("active")
						el.blur()
					}
					$('.header__fav-quantity').text(res['new_count'])
				} else {
					alert(res["error"])
				}
			},
			error: function(err) {
				alert("Ошибка! Попробуйте повотрить запрос. Error: " + err)
			},
		})
	}
	
	applyEvents()
	{
		let _this = this;
		$('.catalog-all__filters input').change(function(){
			_this.loadItems(this);
		});
	}

	getData(params) {
		// let _this = this
		$('.catalog-all__filters-loader').show();
		$('.catalog__table-loader').show();

		$.ajax({
			type: "POST",
			url: '/ajax.php?mid=1',
			dataType: 'html',
			data: params + '&action=loadItems',
			success: function(data)
			{
				$('.catalog__table').replaceWith(data);
				$('.catalog-all__filters-loader').hide();

				$(".catalog__table [data-popup-open]").on("click", function (e) {
					e.preventDefault();
					let dataPopupName = $(this).attr("data-popup-open");
					let popup = $(".popup[data-popup-name=" + dataPopupName + "]");

					if (dataPopupName == 'popup-good')
					{
						let id = $(this).attr("data-id");
						let name = $(this).find('img').attr('alt');
						let img = $(this).find('img').attr('src').replace(/\/small_/, '/');

						let image = popup[0].querySelector('img.popup-good__image')
						image.setAttribute('src','')
						let loader = popup[0].querySelector('.popup__loader')
						loader.style.display = 'block'
						image.onload = function() {
							loader.style.display = 'none'
						}

						popup.find('.popup-good__title').text(name);
						popup.find('.popup-good__image').attr('src', img);
						popup.find('.popup__card').attr('data-id', id);

						if ($(this).closest('.catalog-item').find('.catalog-item__nav-btn--like').hasClass('active'))
							popup.find('.popup-good__like').addClass('active');
						else
							popup.find('.popup-good__like').removeClass('active');
					}

					$("body").addClass("no-scroll");
					popup.addClass("active");
				});
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	to_object(val) {
		if(val.length == 0) return
		let str = val.replaceAll('=','":"')
		str = str.replaceAll('&','","')
		str = '{"' + str + '"}'
		let obj = JSON.parse(str)
		return obj
	}

    in_array(value, array) {
        for (let i = 0; i < array.length; i++) {
            if (array[i] == value) return true
        }
        return false
    }

    setCookie(name, value, expires) {
        if (!expires) {
            expires = new Date();
            expires.setDate(expires.getDate() + 30);
        }
        document.cookie = name + "=" + escape(value) + "; expires=" + expires + "; path=/";
    }

    getCookie(cookie_name) {
        let results = document.cookie.match('(^|;) ?' + cookie_name + '=([^;]*)(;|$)')
        if (results)
            return (unescape(results[2]))
        else
            return null
    }

}